// extracted by mini-css-extract-plugin
module.exports = {"resetBtn":"_1_-hGlCRwxi4hhGeWqMf7F","icon":"_1lRTJ_pDh9kYQgQ_kN6n_q","active":"_1E2m42uTuPemX_7nOgR92Y"};